// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/DirectMessagesImport';
export class CashItemQuoteCache {
    constructor() {
        this.quoteStorage = new LimitedQueue(100);
    }
    newQuote(msg) {
        if (msg.Code === Message.CODE_INSTRUMENT_DAY_BAR) {
            return;
        }
        if (msg.Code === Message.CODE_QUOTE && !msg.IsValid) {
            return;
        }
        this.quoteStorage.add(msg);
    }
    clear() {
        this.quoteStorage.clear();
    }
    getAllQuotes() {
        return this.quoteStorage.getItems();
    }
}
class LimitedQueue {
    constructor(limit) {
        this.queue = [];
        this.limit = limit;
    }
    add(item) {
        if (this.queue.length >= this.limit) {
            this.queue.shift();
        }
        this.queue.push(item);
    }
    getItems() {
        return this.queue;
    }
    count() {
        return this.queue.length;
    }
    clear() {
        this.queue = [];
    }
}
